// 10/9 — 화면 언어가 ja · en · zh-TW · zh-HK 이면 한국어 대사 대신 더빙을 낸다. 영상은 그대로 두고 소리만 바꾼다.
// 외국어 화면에서는 대사 영상 소리를 처음부터 끝까지 끄고(사주 · 타로 화면이 BGDUB.on 을 본다) 한국어로 되돌리지 않는다. ko · 토스 안은 여기가 아무 것도 바꾸지 않는다.
// 목록은 tools/dub_media.py 가 public/app/data/dub-{ja|en|zh|yue}.json 에 적고, 소리 파일은 R2(app/media/dub/{lang}/v2/…)에 있다.
// 사주 · 타로 더빙 파일은 「영상 시간에 맞춘 판」 — 소리 파일의 0초가 대사 영상 클립의 0초다. 그래서 영상이 실제로 도는 동안(미디어 이벤트) 소리를 영상 시각에 맞춰 함께 튼다.
// 화면 갱신(requestAnimationFrame)에는 기대지 않는다 — 크롬 창이 가려져 화면 갱신이 멈추자 더빙이 끝내 시작되지 않아 무음이 됐다(사장님이 실제로 겪음).
(() => {
  if (window.BGDUB) return;
  const supported = (value) => /^zh(?:[-_]|$)/i.test(String(value || "")) ? (/^zh(?:[-_]hant)?[-_](?:hk|mo)(?:[-_]|$)/i.test(String(value)) ? "zh-HK" : "zh-TW") : /^(ko|en|ja)(?:[-_]|$)/i.exec(String(value || ""))?.[1].toLowerCase() || null;
  const toss = () => document.documentElement.dataset.shell === "toss" || globalThis.BGTOSS || /\.tossmini\.com$/.test(location.hostname);
  // i18n.js 와 같은 순서(주소 → 저장값 → 나라 → 기기). 화면 언어 객체가 이미 있으면 그걸 따른다.
  function detect() {
    if (toss()) return "ko";
    let saved = null;
    try { saved = supported(localStorage.getItem("bamgwabi.locale")); } catch { /* 저장값을 못 읽으면 다음 */ }
    const requested = supported(new URL(location.href).searchParams.get("lang"));
    return window.BGLANG?.locale || requested || saved || supported(document.documentElement.dataset.regionLocale) || supported(navigator.languages?.[0] || navigator.language) || "en";
  }
  const fold = { ja: "ja", en: "en", "zh-TW": "zh", "zh-HK": "yue" }[detect()] || null;
  const BASE = `/app/media/dub/${fold}/v2`;
  const origFetch = window.fetch.bind(window);
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  // 끊겨도 받을 때까지 다시 받는다(question-memory.js resource 와 같이 — 12초 동안 한 조각도 안 오면 끊고 다시). 서버가 4xx 로 없다고 할 때만 멈춘다.
  // 한국어 파일로 돌아가지 않는다 — 일본어 화면에서 한국어가 나가는 것 자체가 실패다.
  async function get(url, init) {
    const outer = init?.signal;
    for (let n = 0; ; n++) {
      if (outer?.aborted) throw new DOMException("Aborted", "AbortError");
      const ctl = new AbortController(), stop = () => ctl.abort();
      let last = Date.now();
      const watch = setInterval(() => { if (document.hidden) last = Date.now(); else if (Date.now() - last > 12000) ctl.abort(); }, 500);
      outer?.addEventListener("abort", stop);
      try {
        const r = await origFetch(url, { ...init, signal: ctl.signal });
        if (r.status >= 400 && r.status < 500) return { status: r.status, blob: null };
        if (!r.ok) throw Error(`더빙 받기 ${r.status}`);
        const reader = r.body.getReader(), parts = [];
        for (;;) { const { done, value } = await reader.read(); if (done) break; parts.push(value); last = Date.now(); }
        return { status: r.status, blob: new Blob(parts, { type: "audio/mp4" }) };
      } catch (e) {
        if (outer?.aborted) throw e;
      } finally { clearInterval(watch); outer?.removeEventListener("abort", stop); }
      await sleep(Math.min(4000, 500 * (n + 1)));
    }
  }
  let saju = {}, tarot = {}, voiceKeys = new Set(), holds = { saju: {}, tarot: [] };
  // 더빙이 대사 영상보다 길 때 기다리며 붙잡을 끝 자세 영상 목록(tools/dub_hold.py) — 없으면 예전처럼 대기 영상으로 넘긴다
  const holdP = !fold ? Promise.resolve() : origFetch("/app/data/dub-hold.json", { cache: "no-cache" }).then((r) => (r.ok ? r.json() : null)).then((j) => { if (j?.saju) holds = j; }).catch(() => {});
  const ready = !fold ? Promise.resolve() : Promise.all([get(`/app/data/dub-${fold}.json`, { cache: "no-cache" }).then((x) => x.blob?.text()).then((t) => {
    const j = t ? JSON.parse(t) : {};
    saju = j.saju || {}; tarot = j.tarot || {}; voiceKeys = new Set(j.voice || []);
  }).catch(() => {}), holdP]);
  const dubBytes = new WeakSet(), dubBlobs = new WeakSet(), dubBuffers = new WeakSet();
  // 심리 · 연애 · MBTI 는 영상과 따로 받은 한국어 음성 파일을 재생기 시각(초)으로 자른다. 더빙이 더 길면 그 자르기를 풀어야 끝이 안 잘린다.
  if (fold) {
    const stemOf = (url) => {
      let path;
      try { path = new URL(url, location.href).pathname; } catch { return null; }
      if (path.includes("/app/media/dub/") || path.includes("/app/data/dub-")) return null;
      const m = /^(.*)\.(mp3|wav|m4a|aac)$/i.exec(path.split("/").pop() || "");
      if (!m) return null;
      let stem;
      try { stem = decodeURIComponent(m[1]); } catch { stem = m[1]; }
      return stem.replace(/-[a-f0-9]{12}$/i, "");   // 10/9 MBTI 음성은 이름 뒤에 내용 지문이 붙는다(S00-지문.mp3). 더빙 목록의 줄 이름만 본다
    };
    window.fetch = (input, init) => {
      const url = typeof input === "string" ? input : input instanceof URL ? input.href : input?.url;
      const stem = url && stemOf(url);
      if (!stem) return origFetch(input, init);
      return ready.then(async () => {
        if (!voiceKeys.has(stem)) return origFetch(input, init);
        const got = await get(`${BASE}/voice/${encodeURIComponent(stem)}.m4a`, { signal: init?.signal });
        if (!got.blob) return new Response(null, { status: got.status });
        const bytes = await got.blob.arrayBuffer();
        dubBytes.add(bytes);
        return new Response(bytes, { status: 200, headers: { "Content-Type": "audio/mp4", "x-bg-dub": "1" } });
      });
    };
    const origAB = Response.prototype.arrayBuffer, origBlob = Response.prototype.blob, origBAB = Blob.prototype.arrayBuffer, origSlice = ArrayBuffer.prototype.slice;
    Response.prototype.arrayBuffer = function () {
      const p = origAB.call(this);
      return this.headers?.get?.("x-bg-dub") === "1" ? p.then((b) => { dubBytes.add(b); return b; }) : p;
    };
    Response.prototype.blob = function () {
      const p = origBlob.call(this);
      return this.headers?.get?.("x-bg-dub") === "1" ? p.then((b) => { dubBlobs.add(b); return b; }) : p;
    };
    Blob.prototype.arrayBuffer = function () {
      const p = origBAB.call(this);
      return dubBlobs.has(this) ? p.then((b) => { dubBytes.add(b); return b; }) : p;
    };
    ArrayBuffer.prototype.slice = function (...args) {
      const out = origSlice.apply(this, args);
      if (dubBytes.has(this)) dubBytes.add(out);
      return out;
    };
    const markDecode = (proto) => {
      const orig = proto.decodeAudioData;
      proto.decodeAudioData = function (data, ok, err) {
        const dub = data && dubBytes.has(data);
        const mark = (b) => { if (dub && b) dubBuffers.add(b); return b; };
        if (typeof ok === "function") return orig.call(this, data, (b) => ok(mark(b)), err);
        const p = orig.call(this, data);
        return p && typeof p.then === "function" ? p.then(mark) : p;
      };
    };
    const AC = globalThis.AudioContext || globalThis.webkitAudioContext;
    if (AC) markDecode(AC.prototype);
    const Start = globalThis.AudioBufferSourceNode;
    if (Start) {
      const origStart = Start.prototype.start;
      Start.prototype.start = function (when, offset, duration) {
        if (this.buffer && dubBuffers.has(this.buffer) && typeof duration === "number") {
          const full = Math.max(0, this.buffer.duration - (typeof offset === "number" ? offset : 0));
          if (duration < full - 0.03) duration = full;
        }
        return origStart.call(this, when, offset, duration);
      };
    }
  }
  // 받아 둔 더빙(주소 → blob 주소). 대사 영상과 함께 미리 받는다(사주 preload · 타로 preloadLine). 늘 최근 몇 개만 둔다.
  const kept = new Map();
  function load(url) {
    if (!kept.has(url)) {
      const p = get(url).then((x) => (x.blob ? URL.createObjectURL(x.blob) : null));
      kept.set(url, p);
      p.then((u) => { if (!u) kept.delete(url); });
      for (const [old, q] of kept) {
        if (kept.size <= 12) break;
        if (old === url) continue;
        kept.delete(old);
        q.then((u) => { if (u && audio?.getAttribute("src") !== u) URL.revokeObjectURL(u); });
      }
    }
    return kept.get(url);
  }
  // 사주 · 타로는 대사 소리가 영상 안에 있다. 풀어 둔 소리 요소 하나로 더빙을 내고, 영상 요소는 소리를 끈다.
  // 아이폰은 누른 순간에 한 번 튼 요소만 나중에 소리를 낸다 — arm 은 영상 unlock 과 같이 그 누름 안에서 부른다.
  let audio = null, cur = null;
  const el = () => {
    if (audio) return audio;
    audio = new Audio(); audio.preload = "auto"; audio.setAttribute("playsinline", "");
    audio.addEventListener("ended", () => { if (audio.ended) cur?._end(); });
    return audio;
  };
  /* 대사 영상 v 에 더빙을 묶는다. ct() — 영상의 클립 안 시각. segs — 소리 파일 안 말(문장)마다 [시작, 끝](목록).
     · 영상이 실제로 돌기 시작하면(playing · seeked) 소리를 ct() 에 맞춰 함께 튼다. 멈추면(pause · waiting · seeking — 화면 벗어남 · 건너뛰기 · 받는 중) 소리도 멈춘다.
     · 영상이 이 줄 끝에 닿으면(release — 영상이 먼저 끝나 대기 영상으로 돌아가도) 소리는 혼자 끝까지 돈다. ended 가 오면 done 이 풀린다.
     · 소리를 못 틀면(아이폰이 막음 — NotAllowedError) blocked 로 두고 끝난 것으로 친다(줄이 멈추지 않게). 한국어 소리는 켜지 않는다. */
  function bind(v, ct, src, segs) {
    const a = el();
    cur?.stop();
    const h = { ended: false, free: false, blocked: false, dead: false };
    let fire;
    h.done = new Promise((r) => (fire = r));
    const evs = { playing: () => align(), seeked: () => { if (!v.paused) align(); }, pause: () => halt(), waiting: () => halt(), seeking: () => halt(), timeupdate: () => drift() };
    const off = () => Object.entries(evs).forEach(([e, f]) => v.removeEventListener(e, f));
    let tick = 0, lastT = -1, still = 0, heldFree = false, catchUp = 0;
    h._end = () => { if (h.ended) return; h.ended = true; off(); clearInterval(tick); clearTimeout(catchUp); document.removeEventListener("visibilitychange", vis); removeEventListener("bamgwabi:payhold", onPay); if (cur === h) cur = null; fire(); };
    const start = () => { const p = a.play(); if (p) p.catch((e) => { if (e?.name === "NotAllowedError" && cur === h) { h.blocked = true; h._end(); } }); };
    const near = (t) => a.readyState >= 1 && Number.isFinite(a.duration) && t >= a.duration - 0.02;
    function align() {
      clearTimeout(catchUp); catchUp = 0;
      if (cur !== h || h.free) return;
      if (a.readyState < 1) { a.addEventListener("loadedmetadata", () => { if (!v.paused) align(); }, { once: true }); return; }
      const t = Math.max(0, ct());
      if (near(t)) return;
      if (Math.abs(a.currentTime - t) > 0.03) a.currentTime = t;
      if (a.paused) start();
    }
    function halt() {
      clearTimeout(catchUp); catchUp = 0;
      if (cur !== h || h.free) return;
      if (v.ended) { h.release(); return; }   // 영상이 끝까지 돌아 멈춘 것 — 소리는 이어 간다
      if (!a.paused) a.pause();
    }
    // 영상이 알림(waiting) 없이 버벅여 뒤처지면(틀기 시작 직후 장면 풀기 등) 소리가 0.1초 넘게 앞선다 — 그만큼 소리를 쉬었다가 영상 시각에 맞춰 다시 튼다
    // (뒤로 감으면 같은 소리가 되풀이된다). 소리가 0.1초 넘게 뒤처지면 앞으로 맞춘다. 소리 빠르기는 바꾸지 않는다(아이폰은 빠르기를 바꾸면 소리를 다시 낸다)
    function drift() {
      if (cur !== h || h.free || catchUp || v.paused || a.paused || a.readyState < 1) return;
      const t = ct(), d = a.currentTime - t;
      if (near(t)) return;
      if (d > 0.1) { a.pause(); catchUp = setTimeout(() => { catchUp = 0; if (!v.paused) align(); }, d * 1000); }
      else if (d < -0.1) a.currentTime = t;
    }
    let payHeld = false;
    function vis() {   // 영상과 떨어져 혼자 도는 동안 화면을 벗어나거나 결제창이 열리면 멈췄다가, 돌아오면 잇는다(묶인 동안은 영상 멈춤이 소리를 멈춘다)
      if (!h.free || h.ended) return;
      if (document.hidden || payHeld) { if (!a.paused) { heldFree = true; a.pause(); } }
      else if (heldFree) { heldFree = false; start(); }
    }
    document.addEventListener("visibilitychange", vis);
    const onPay = (e) => { payHeld = !!e.detail; vis(); };
    addEventListener("bamgwabi:payhold", onPay);
    h.release = () => {
      if (cur !== h || h.free || h.ended) return;
      h.free = true; off();
      if (a.paused) { const t = Math.max(a.currentTime, ct() - 0.25); if (near(t)) { h._end(); return; } a.currentTime = t; if (!document.hidden && !payHeld) start(); else heldFree = true; }
      // 혼자 도는 소리가 멈춘 채면 다시 틀고, 8초 넘게 안 움직이면 끝난 것으로 친다(줄이 끝내 안 넘어가지 않게). 화면을 벗어난 동안 · 결제창이 열린 동안은 세지 않는다
      tick = setInterval(() => {
        if (h.ended || document.hidden || payHeld) { still = 0; return; }
        if (a.paused && !heldFree) start();
        if (a.currentTime === lastT) { if (++still >= 8) h._end(); } else { still = 0; lastT = a.currentTime; }
      }, 1000);
    };
    h.stop = () => { if (h.dead) return; h.dead = true; if (cur === h && !a.paused) a.pause(); h._end(); };
    h.time = () => (cur === h ? a.currentTime : -1);
    // 자막이 따를 말(문장) 번호 — 말 시작 0.1초 전부터. 문장 사이 쉼에는 앞 문장을 둔다. 시작 전 · 끝난 뒤 · 못 튼 때는 -1
    h.line = () => {
      if (h.ended || cur !== h || !segs?.length) return -1;
      const t = a.currentTime;
      let i = -1;
      for (let k = 0; k < segs.length; k++) if (t >= segs[k][0] - 0.1) i = k;
      return i;
    };
    cur = h;
    if (a.getAttribute("src") !== src) a.src = src;
    a.currentTime = Math.max(0, ct());
    Object.entries(evs).forEach(([e, f]) => v.addEventListener(e, f));
    if (!v.paused && v.readyState >= 3) align();   // 이미 도는 영상에 묶일 때
    return h;
  }
  window.BGDUB = {
    get on() { return !!fold; },
    ready,
    // 끝 자세 영상이 있는 줄인가 — kind "saju"(no = 인물 번호) · "tarot"
    hold(kind, no, key) {
      if (!fold) return false;
      return kind === "tarot" ? holds.tarot?.includes(key) : !!holds.saju?.[String(no).padStart(2, "0")]?.includes(key);
    },
    // 사주 줄 더빙 → { url, segs: [[말 시작, 끝]] } | null(그 줄은 말이 없다)
    async saju(no, key) {
      await ready;
      const id = String(no).padStart(2, "0"), span = fold && saju[id]?.[key];
      return span ? { url: `${BASE}/saju/${id}/${encodeURIComponent(key)}.m4a`, segs: [span] } : null;
    },
    // 타로 클립 더빙 → { url, segs: [[문장 시작, 끝], …] } | null
    async tarot(id) {
      await ready;
      const segs = fold && tarot[id];
      return segs?.length ? { url: `${BASE}/tarot/${encodeURIComponent(id)}.m4a`, segs } : null;
    },
    load, bind,
    arm(silent) {
      const a = el();
      a.src = silent;
      const p = a.play(); if (p) p.catch(() => {});
      a.pause(); a.removeAttribute("src");
      try { a.load(); } catch { /* 비우기 */ }
    },
    stop() { cur?.stop(); },
  };
})();
